import { useLingui } from "@lingui/react";
import type { ReactNode } from "react";

type Props = {
  icon: ReactNode;
  label: string;
  info: string | number | undefined | null;
};

const Detail = ({ icon, label, info }: Props) => {
  const { i18n } = useLingui();
  const undefinedLabel = i18n._({
    id: "itemPageLayout.sectionSummary.notSpecified",
    message: "Not specified",
    comment: "Label for unspecified value in ad section summary",
  });
  return (
    <div className="flex gap-16 hyphens-auto">
      <div className="flex items-center">{icon}</div>
      <div>
        <span className="s-text-subtle">{label}</span>
        <p className="m-0 font-bold">{info != null ? info : undefinedLabel}</p>
      </div>
    </div>
  );
};

export default Detail;
